import { useThemeContext } from './ThemeProvider';

interface Props {
  alt?: string;
  className?: string;
  height?: number;
  style?: React.CSSProperties;
  // Força a variante branca (para fundos escuros) independentemente do tema
  // global. O Stage do BigPicture é sempre escuro, mesmo com tema global
  // light — sem isto o logo ficava azul sobre o palco escuro.
  forDarkBackground?: boolean;
}

export default function KaraokrLogo({ alt = 'Karaokr', className = '', height, style, forDarkBackground = false }: Props) {
  const { resolvedTheme } = useThemeContext();
  const src =
    forDarkBackground || resolvedTheme === 'dark' ? '/karaokr-logo.png' : '/karaokr-logo-light.png';
  return (
    <img
      src={src}
      alt={alt}
      className={`karaokr-logo ${className}`}
      style={{ ...style, ...(height ? { height } : {}) }}
    />
  );
}
